export const visit = (vm, at) => {
at({ "es": { "conversationsVisitorUIAvailability": { "sameDay": "Regresaremos hoy a las {{time}}", "nextDay": "Regresaremos ma\xF1ana a las {{time}}", "nextWeek": "Regresaremos el {{dayOfWeek}} a las {{time}}" } } });
};